/**
 * "Your session will end soon" — see the shared `useSessionExpiryWarning` doc comment for the
 * full reasoning. On the till specifically: this only ever appears on a genuinely idle tab, since
 * any tap renews the session silently (`useKeepSessionAlive`) well before this warning window opens.
 */

import { useKeepSessionAlive, useSessionExpiryWarning } from '@pos/shared';

export function SessionExpiryBanner() {
  // Real clicks and typing renew the session, so this banner only ever reaches someone idle.
  useKeepSessionAlive();
  const { isExpiringSoon, secondsRemaining } = useSessionExpiryWarning();

  if (!isExpiringSoon || secondsRemaining === null) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 bg-warning-subtle px-4 py-2 text-sm font-semibold text-warning-subtle-text"
      data-print="hide"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      Signing out in {secondsRemaining}s if this stays idle — tap anywhere to stay signed in.
    </div>
  );
}
